<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#completed" @click="activeComponent='tabTasks'"><i class="fa fa-tasks"></i> Tasks</a></li>
        <li v-if="order && order.types && order.types.includes('content')"><a class="nav-link" data-toggle="tab" href="#content" @click="activeComponent='tabContent'"><i class="far fa-file-alt"></i> Content</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row" v-if="activeComponent">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TabTasks from './Tabs/Tasks'
import TabContent from './Tabs/Content'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      activeComponent: 'tabTasks'
    }
  },
  computed: {
    ...mapGetters({
      order: 'getMaintenanceOrder'
    })
  },
  components: {
    tabTasks: TabTasks,
    tabContent: TabContent
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Order/Content.vue